import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["none", "radio"]

  connect() {
    // Mark any pre-selected radio as checked
    this.radioTargets.forEach(radio => {
      if (radio.checked) {
        radio.dataset.wasChecked = true
      }
    })
  }

  // We need to react to click because "change" isn't fired
  // when activating the *currently selected* option
  toggle(event) {
    const radio = event.currentTarget

    // Select "none" option if the current target was already checked
    if (radio.dataset.wasChecked) {
      this.noneTarget.checked = true
      this.radioTargets.forEach(input => delete input.dataset.wasChecked)
    } else {
      // Mark this radio as checked for next time
      this.radioTargets.forEach(input => delete input.dataset.wasChecked)
      radio.dataset.wasChecked = true
      radio.checked = true
    }
  }
}
